/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssetAnnotationDto { 
    assetsId: string;
    assetVersionsId: string;
    annotationChild?: object;
    annotationChildItemId?: string;
    annotationChildItem?: object;
    reply?: string;
    desiredAction: object;
}

